module.exports = __webpack_public_path__ + "static/Dyes-Banner-Img-7fa36813f36aa338f27044cc1a188b54.png";